var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAudit = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M3 1.25A1.75 1.75 0 0 0 1.25 3v10c0 .966.784 1.75 1.75 1.75h5a.75.75 0 0 0 0-1.5H3a.25.25 0 0 1-.25-.25V3A.25.25 0 0 1 3 2.75h8a.25.25 0 0 1 .25.25v2a.75.75 0 0 0 1.5 0V3A1.75 1.75 0 0 0 11 1.25H3zM4 4.5a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H4zM3.5 7a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H4a.5.5 0 0 1-.5-.5zM4 8.5a.5.5 0 0 0 0 1h2a.5.5 0 0 0 0-1H4zm7 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zm2.585.024a3 3 0 1 0-1.06 1.06l.945.946a.75.75 0 1 0 1.06-1.06l-.945-.946z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAudit);
export default ForwardRef;